import React from "react";
import { TopNav } from "@/components/TopNav";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { useLang } from "@/context/LanguageContext";
import { legalTr } from "@/i18n/legalTranslations";
import { Scale } from "lucide-react";

const TermsPage = () => {
  const { lang } = useLang();
  const L = legalTr[lang];
  const T = L.terms;
  return (
    <div className="min-h-screen bg-[#050811] text-[#F8F5EE] flex flex-col">
      <SEO
        title={T.title}
        path="/terms"
        description={
          lang === "fr"
            ? "Conditions générales de vente et d'utilisation du service GEM PRICE."
            : "GEM PRICE terms and conditions of sale and use."
        }
      />
      <TopNav />
      <main className="flex-1 px-6 md:px-14 py-14" data-testid="terms-page">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <Scale size={20} className="text-[#C1A661]" strokeWidth={1.3} />
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#C1A661]">
              {L.updated} — {L.updatedDate}
            </span>
          </div>
          <h1
            className="font-serif font-light text-4xl md:text-5xl tracking-[0.06em] text-[#E2CFA4] mb-6"
            data-testid="terms-title"
          >
            {T.title}
          </h1>
          <p className="text-[#A1A7B3] font-light leading-relaxed mb-10">{T.intro}</p>

          <div className="space-y-8">
            {T.sections.map((s, i) => (
              <section key={i} className="border-l border-[#C1A661]/25 pl-5">
                <h2 className="font-serif text-xl text-[#E2CFA4] mb-2">{s.h}</h2>
                <p className="text-sm text-[#A1A7B3] leading-relaxed">{s.p}</p>
              </section>
            ))}
          </div>

          <div className="mt-14 p-5 border border-[#C1A661]/25 rounded-sm bg-[#0A0F1F]/60">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C1A661] mb-1">
              {L.contactLabel}
            </div>
            <a
              href={`mailto:${L.contactValue}`}
              className="text-[#E2CFA4] hover:text-[#C1A661] transition-colors"
              data-testid="terms-contact-email"
            >
              {L.contactValue}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
